import React from 'react';
import { ArrowUpRight, Building2, ChevronRight, Clock3, Globe2, Leaf, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
import { Localized } from '../../i18n/I18n';
import { contactData } from '../../data/mock';
import { LegalFooterLinks } from '../privacy/PrivacyCenter';
import BrandLogo from './BrandLogo';
import './footer.css';

function WhatsAppIcon() {
  return <svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20.5 11.8a8.5 8.5 0 0 1-12.6 7.5L3 20.6l1.3-4.8a8.5 8.5 0 1 1 16.2-4Z"/><path d="m8.3 7.4 1.2-.1.9 2.1-.8 1.1a7.2 7.2 0 0 0 3.6 3.5l1.1-.8 2.1.9-.1 1.2c-.2.9-1 1.3-1.9 1.1-3.4-.7-6.1-3.4-6.8-6.8-.2-.9.2-1.7.7-2.2Z"/></svg>;
}

const explore = [['Soluciones', '/servicios'], ['IA en acción', '/#en-accion'], ['Cómo trabajamos', '/#metodo'], ['Nuestro equipo', '/#about'], ['Compromiso social', '/#proposito']];

export default function SiteFooter() {
  const whatsapp = `https://wa.me/${contactData.whatsapp.replace(/\D/g, '')}`;
  const phone = contactData.phone.replace(/\s/g, '').replace(/^(\+\d{2})(\d{3})(\d{3})(\d{4})$/, '$1 $2 $3 $4');
  return <Localized><footer id="pie-de-pagina" className="bz-footer bz-footer-v2">
    <div className="bz-footer-waves" aria-hidden="true"/>
    <div className="bz-shell bz-footer-inner">
      <div className="bz-footer-grid">
        <div className="bz-footer-identity">
          <a href="/#hero" className="bz-brand" aria-label="Bezalel Technology — Inicio"><BrandLogo/></a>
          <p>Conectamos tecnología.<br/>Impulsamos posibilidades.</p>
          <div className="bz-footer-socials">
            <a href="https://www.linkedin.com/company/bezalel-technology" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn de Bezalel"><Linkedin size={20} aria-hidden="true"/></a>
            <a href={whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Escribir por WhatsApp"><WhatsAppIcon/></a>
            <a href={`mailto:${contactData.email}`} aria-label="Enviar un correo"><Mail size={20} aria-hidden="true"/></a>
          </div>
        </div>
        <nav className="bz-footer-explore" aria-labelledby="bz-footer-explore-title">
          <h2 id="bz-footer-explore-title" className="bz-footer-heading">EXPLORA</h2>
          <ul>{explore.map(([label, href]) => <li key={href}><a href={href}>{label}<ChevronRight size={16} aria-hidden="true"/></a></li>)}</ul>
        </nav>
        <section className="bz-footer-connect" aria-labelledby="bz-footer-connect-title">
          <h2 id="bz-footer-connect-title" className="bz-footer-heading">CONECTEMOS</h2>
          <ul className="bz-footer-details">
            <li><Mail aria-hidden="true"/><a href={`mailto:${contactData.email}`}>{contactData.email}</a></li>
            <li><Phone aria-hidden="true"/><a href={`tel:${contactData.phone.replace(/\s/g, '')}`}>{phone}</a></li>
            <li><WhatsAppIcon/><a href={whatsapp} target="_blank" rel="noopener noreferrer">WhatsApp <ArrowUpRight size={15} aria-hidden="true"/></a></li>
            <li><MapPin aria-hidden="true"/><span>Arjona, Bolívar · Colombia</span></li>
          </ul>
        </section>
        <section className="bz-footer-hours" aria-labelledby="bz-footer-hours-title">
          <h2 id="bz-footer-hours-title" className="bz-footer-heading">Horario de atención</h2>
          <ul className="bz-footer-details">
            <li><Clock3 aria-hidden="true"/><div><p>Lunes a viernes</p><span>8:00 a. m. – 5:00 p. m.</span></div></li>
            <li><Globe2 aria-hidden="true"/><span>Hora de Colombia</span></li>
            <li><Building2 aria-hidden="true"/><div><p>Soporte empresarial</p><span>Horario y cobertura acordados con cada empresa.</span></div></li>
          </ul>
        </section>
      </div>
      <a href="/#hero" className="bz-back-top" aria-label="Volver al inicio"><ArrowUpRight size={23} aria-hidden="true"/></a>
      <div className="bz-footer-bottom">
        <p>© {new Date().getFullYear()} Bezalel Technology. <span>Todos los derechos reservados.</span></p>
        <p className="bz-footer-purpose"><Leaf size={15} aria-hidden="true"/>Hecho con propósito.</p>
        <LegalFooterLinks/>
      </div>
    </div>
  </footer></Localized>;
}
